export const ENV = process.env.NODE_ENV
export const PROD_GA_TRACKING = process.env.REACT_APP_GA_PROD || null
export const NON_PROD_GA_TRACKING = process.env.REACT_APP_GA_NON_PROD || null
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
